export interface Cliente{
    id: number
    nome: string
    documento: string
    telefone: string
    email: string
    cep: string
    logradouro: string
    numero: string | number | null
    complemento: string
    bairro: string
    cidade: string
    estado: string
    comoConheceu: string
}

export const initialStateCliente: Cliente = {
    id: 0,
    nome: "",
    documento: "",
    telefone: "",
    email: "",
    cep: "",
    logradouro: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    estado: "",
    comoConheceu: "",
  };

  export interface FormPesquisarCliente {
    nome: string;
    documento: string;
  }